import React from "react";
import "./PLMSolutionsAMCPage.css";
import PLMSolutionsAMCOverview from "./PLMSolutionsAMCOverview";
import BannerImage from "../../../assets/other_image/Amc.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const PLMSolutionsAMCPage = () => {
  return (
    <section className="PLMSolutionsAMC-process">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Solutions AMC" // Pass the heading text for this page
      />
            <FloatingContactUs />
      <div className="container">
        <PLMSolutionsAMCOverview />
        <div className="benefits">
          <h4 className="PLMSolutionsAMC-page-heading">Unlock the Power :</h4>
          <h5 className="PLMSolutionsAMC-subheading">
            Discover the Transformative Benefits of Teamcenter Solutions AMC with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>Proven global PLM support service expertise. </li>
            <li>
              Dedicated team of PLM experts committed to service excellence.
            </li>
            <li>Specialization in mission-critical PLM systems.</li>
            <li>Data privacy assurance with trustworthy PLM experts.</li>
            <li>
              Flexible onsite, offsite, or mixed support models for cost
              optimization.
            </li>
          </ul>
        </div>

        <div className="why-nextech">
          <h4 className="PLMSolutionsAMC-page-heading">Why NexTech?</h4>
          <h5 className="PLMSolutionsAMC-subheading">
            For Teamcenter Solutions AMC
          </h5>
          <ul className="custom-bullets">
            <li>
              NexTech Teamcenter solutions support is a proven service, serving
              clients across the world.
            </li>
            <li>
              Our PLM support team consists of PLM experts with a commitment to
              excellence in service.
            </li>
            <li>
              NexTech resources are specialized in PLM solutions for
              mission-critical PLM system
            </li>
            <li>
              NexTech protects your data privacy and uses only trustworthy PLM
              experts.
            </li>
            <li>
              Customer has the choice to select onsite or offsite or mix model
              which ensures optimum cost.
            </li>
          </ul>
        </div>

        <div className="solutions">
          <h4 className="PLMSolutionsAMC-page-heading">
            Nextech's Technical Support includes
          </h4>
          <ul className="custom-bullets">
            <li>Day-to-day Teamcenter functional issue resolution</li>
            <li>
              Troubleshooting and guiding the users for various activities.
            </li>
            <li>
              Providing support to interface applications linked to Teamcenter
              like S E, MSO etc.
            </li>
            <li>Enabling best practices for using Teamcenter PLM.</li>
          </ul>
        </div>

        <div className="solutions">
          <h4 className="PLMSolutionsAMC-page-heading">
            Nextech’s System Administration includes
          </h4>
          <ul className="custom-bullets">
            <li>Monitoring & maintaining Teamcenter production server.</li>
            <li>
              Monitoring & maintaining database server where industry IP is
              stored.
            </li>
            <li>
              Performance Tuning for server & client including hardware,
              software, and network.
            </li>
            <li>
              Teamcenter Server and Client Patching, Hardware, OS upgrade.
            </li>
          </ul>
        </div>

        <div className="solutions">
          <h4 className="PLMSolutionsAMC-page-heading">
          NexTech’s unique process to get AMC Done 
          </h4>
          <ul className="custom-bullets">
            <li>PLM Subject Matter Expert Visit for as is the analysis  </li>
            <li>
            Requirement specification covering AMC scope  
            </li>
            <li>
            Customer agreement  
            </li>
            <li>
            Actual work start 
            </li>
            <li>
            Every six-month audit of AMC to ensure the expectation is meeting. 
            </li>
          </ul>
        </div>

        <div className="solutions">
          <h4 className="PLMSolutionsAMC-page-heading">
          Nextech's Advanced Solution Development for AMC  
          </h4>

          <h5>Development of New Capabilities:</h5>
          <p className="plmimplementationparagraph">
          Teamcenter is an Enterprise system and hence its demands adding new capabilities for the various business need like manufacturing data and process management, change management, CAD-BOM alignment, CAE data and process management, and many more while addressing various requirement across the organization.  This calls for the development of new capabilities using Teamcenter Solutions for addressing business goals. 
          </p>

          <h5>Redefining Existing Capabilities:</h5>
          <p className="plmimplementationparagraph">
          It may happen that whatever the existing capabilities developed using Teamcenter Solutions are not up-to-date and as per the standard and hence not sufficing the business requirement efficiently & effectively. AMC addresses requirement by redefining existing Solution in Teamcenter using better standard and approaches.  
          </p>

          <h5>Regression Testing:</h5>
          <p className="plmimplementationparagraph">
          Developing and redefining capabilities always calls for regression testing of various functionalities. AMC addresses this need by engaging right testing methodology to ensure the functionality working. 
          </p>

          <h5>Usage Centric Training: </h5>
          <p className="plmimplementationparagraph">
          Right training is always being challenge for Industry while adapting and using Technology like Teamcenter PLM while achieving business goal.  Right training at right time in right context help user to use the technology effectively and efficiently. AMC addressed this need systematically. 
          </p>
          <ul className="custom-bullets">
            <li>Providing training as and when required for smooth functioning of business using PLM system to new users. </li>
            <li>
            Training on new modules and functionalities. 
            </li>
            <li>
            Creation and maintenance of knowledge base for users by creating end user usage specific user manuals. 
            </li>
            <li>
            Use case development for day to day usage. 
            </li>
          </ul>
        </div>
       
      </div>
      <Letsgetintouch />
    </section>
  );
};

export default PLMSolutionsAMCPage;
